import { prop } from "ramda";

function handleFormErrors(key, form) {
  if (form.errors) return prop(key, form.errors);
  return null;
}

export default handleFormErrors;
